import type { VXETableCore } from 'vxe-table'
import { useFormat } from '@/composables'
import { is } from '@/components/SjzyInputNumber'

const { formatAmount, formatToDate } = useFormat()

export const VXETablePluginFormats = {
  install(vxetablecore: VXETableCore) {
    const { formats } = vxetablecore

    // 时间格式化
    formats.add('formatTime', {
      cellFormatMethod: ({ cellValue }: any, format: string, isTimestamp: boolean) => {
        return cellValue ? formatToDate(cellValue, format, isTimestamp) : ''
      },
    })

    // 金额格式化
    formats.add('formatAmount', {
      cellFormatMethod: ({ cellValue }: any, format: string) => {
        if (typeof cellValue === 'number')
          return formatAmount(cellValue, format)

        if (cellValue === '--' || !cellValue)
          return '--'

        return cellValue ? formatAmount(cellValue, format) : '--'
      },
    })
    // 空值格式化
    formats.add('formatEmpty', {
      cellFormatMethod: ({ cellValue }: any, format = '--') => {
        return (is.isString(cellValue) && !/^\s*$/.test(cellValue))
          || is.isNumber(cellValue || is.isBoolean(cellValue))
          ? cellValue
          : format
      },
    })
  },
}

if (typeof window !== 'undefined' && window.VXETable && window.VXETable.use)
  window.VXETable.use(VXETablePluginFormats)

export default VXETablePluginFormats
